import { z } from "zod";
import { create } from "zustand";

const editCompanySchema = z.object({
  id: z.string(),
  companyName: z.string({ message: "Company name is required" }),
  companyAddress: z.string({ message: "Company Address is required" }),
  companyEmail: z.string().email({ message: "Must be a valid email address" }),
  companyState: z.string(),
  companyCity: z.string(),
  companyZip: z.string(),
});

type EditCompanyType = z.infer<typeof editCompanySchema>;

interface company {
  company: EditCompanyType | null;
  setCompany: (company: EditCompanyType | null) => void;
}

export const useCompany = create<company>()((set) => ({
  company: null,
  setCompany: (company) => set({ company }),
}));
